import React, { useEffect, useState } from "react";

import { dateToInputValue, inputValueToDate } from "shared/lib/dateInput";
import { Button } from "shared/ui/Button";
import { DateField } from "shared/ui/DateField";
import { LabeledField } from "shared/ui/LabeledField";
import { Modal } from "shared/ui/Modal";

interface MarkInvoicePaidDialogProps {
    open: boolean;
    invoiceId: string | null;
    saving: boolean;
    onClose: () => void;
    onConfirm: (paidAt: number) => void;
}

export const MarkInvoicePaidDialog = ({
    open,
    invoiceId,
    saving,
    onClose,
    onConfirm,
}: MarkInvoicePaidDialogProps) => {
    const [paidAt, setPaidAt] = useState("");

    // По умолчанию сегодня, но дату меняют: счета отмечают задним числом, когда деньги дошли.
    useEffect(() => {
        if (open) setPaidAt(dateToInputValue(new Date()));
    }, [open]);

    const parsed = inputValueToDate(paidAt);

    return (
        <Modal
            open={open}
            onClose={onClose}
            title="Отметить счёт оплаченным"
            maxWidth="xs"
            actions={
                <>
                    <Button variant="text" color="neutral" onClick={onClose} disabled={saving}>
                        Отмена
                    </Button>
                    <Button
                        onClick={() => parsed && onConfirm(parsed.getTime())}
                        disabled={saving || !parsed}
                    >
                        Отметить оплаченным
                    </Button>
                </>
            }
        >
            <LabeledField
                label="Дата оплаты"
                htmlFor="paidAt"
                hint={`Счёт № ${invoiceId ?? ""}. От этой даты продлевается тариф заведения.`}
            >
                <DateField id="paidAt" value={paidAt} onChange={setPaidAt} disabled={saving} />
            </LabeledField>
        </Modal>
    );
};
